import { Loader2 } from 'lucide-react'
import { cn } from '../utils'
import { useTranslation } from '@clofo/i18n'

function LoadingSpinner({ className, ...props }: React.ComponentProps<'svg'>) {
  const { t } = useTranslation()

  return (
    <Loader2
      className={cn('animate-spin text-primary w-5 h-5', className)}
      role='status'
      aria-label={t('common.loading')}
      {...props}
    />
  )
}

export { LoadingSpinner }
